export default "__VITE_ASSET__UpWagQL9__"